module.exports = "pegasus_template/assets/email1-column-6.png";